<form #formConsultar="ngForm">
    <div fxLayout="column" fxFlexFill style="margin: 10px 0;">
        <div fxLayout="row" fxLayoutGap="5%" style="margin-bottom: 20px">
            <div ngModelGroup="comboPublicoAlvo" fxFlex="100">
                <combo-publico-alvo
                        [label]="'Público Alvo'"
                        [showDisplayId]="false" 
                        [obrigatorio]="false" 
                        [selecionado]="publicoAlvo"
                        (valorChange)="onDescricaoChangePublicoAlvo($event)">
                </combo-publico-alvo>
        </div>
        </div>
    </div>
</form>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>


    <button *ngIf="!isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary"
            (click)="zerarCombos()">
        Limpar
    </button>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="adicionar()">
        Adicionar
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="cancelar()">
        Cancelar
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            [disabled]=formConsultar.invalid (click)="atualizar()">
        Atualizar
    </button>


</div>
